import { useState } from 'react';
import BootstrapForm from 'react-bootstrap/Form';
import CheckboxRadio from 'components/common/CheckboxRadio/CheckboxRadio';

/**
 * Examples of Checkbox and Radio Button component.
 */

function RadioGroup1(): JSX.Element {
  const [selectedCheckbox, setSelectedCheckbox] = useState('Option 1');
  return (
    <BootstrapForm.Group>
      <CheckboxRadio
        type="radio"
        label="Option 1"
        onChange={() => setSelectedCheckbox('Option 1')}
        checked={selectedCheckbox === 'Option 1'}
      />
      <CheckboxRadio
        type="radio"
        label="Option 2"
        onChange={() => setSelectedCheckbox('Option 2')}
        checked={selectedCheckbox === 'Option 2'}
      />
    </BootstrapForm.Group>
  );
}
function RadioGroup2(): JSX.Element {
  const [selectedCheckbox, setSelectedCheckbox] = useState('Option 1');
  return (
    <BootstrapForm.Group>
      <CheckboxRadio
        type="radio"
        label="Option 1"
        disabled
        onChange={() => setSelectedCheckbox('Option 2')}
        checked={selectedCheckbox === 'Option 1'}
      />
      <CheckboxRadio type="radio" label="Option 2" disabled checked={selectedCheckbox === 'Option 2'} />
    </BootstrapForm.Group>
  );
}
function CheckboxGroup1(): JSX.Element {
  const [option1Checked, setOption1Checked] = useState(true);
  const [option2Checked, setOption2Checked] = useState(false);
  return (
    <BootstrapForm.Group>
      <CheckboxRadio
        type="checkbox"
        label="Option 1"
        checked={option1Checked}
        onChange={() => setOption1Checked(!option1Checked)}
      />
      <CheckboxRadio
        type="checkbox"
        label="Option 2"
        checked={option2Checked}
        onChange={() => setOption2Checked(!option2Checked)}
      />
    </BootstrapForm.Group>
  );
}
function CheckboxGroup2(): JSX.Element {
  return (
    <BootstrapForm.Group>
      <CheckboxRadio type="checkbox" label="Option 1" checked disabled />
      <CheckboxRadio type="checkbox" label="Option 2" disabled />
    </BootstrapForm.Group>
  );
}

function SwitchExamplePage(): JSX.Element {
  return (
    <section id="checkboxRadio" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Checkbox/Radio Button</h1>
      <div className="ExamplesPage__ExampleGrid">
        <div>
          <div className="ExamplesPage__Subhead mb-2">Radio Buttons</div>
          <RadioGroup1 />
        </div>
        <div>
          <div className="ExamplesPage__Subhead mb-2">Disabled</div>
          <RadioGroup2 />
        </div>
        <div>
          <div className="ExamplesPage__Subhead mb-2">Checkboxes</div>
          <CheckboxGroup1 />
        </div>
        <div>
          <div className="ExamplesPage__Subhead mb-2">Disabled</div>
          <CheckboxGroup2 />
        </div>
      </div>
    </section>
  );
}

export default SwitchExamplePage;
